import { Deal } from "@hopper-proto/hopper/dealfeed/proto/v1/Deal";
import { DealPrediction } from "@hopper-proto/hopper/dealfeed/proto/v1/DealPrediction";
import { Dayjs, default as dayjs } from "dayjs";

// Helper function to get deal departure date in YYYY-MM-DD format
export function getDealDepartureDate(deal: Deal): string | null {
  const departureDate = deal.departureDate;
  if (!departureDate) return null;

  const year = departureDate.year || 0;
  const month = departureDate.month || 0;
  const day = departureDate.day || 0;

  if (!year || !month || !day) return null;

  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function getDealDepartureDayjs(deal: Deal): Dayjs | undefined {
  const departureDateStr = getDealDepartureDate(deal);
  return departureDateStr ? dayjs(departureDateStr) : undefined;
}

// Helper function to get deal return date in YYYY-MM-DD format
export function getDealReturnDate(deal: Deal): string | null {
  const returnDate = deal.returnDate;
  if (!returnDate) return null;

  const year = returnDate.year || 0;
  const month = returnDate.month || 0;
  const day = returnDate.day || 0;

  if (!year || !month || !day) return null;

  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

// Helper function to get deal price amount
export function getDealPrice(deal: Deal): number | null {
  return deal.price?.amount?.value ? Number(deal.price.amount.value) : null;
}

// Helper function to get deal currency
export function getDealCurrency(deal: Deal): string {
  return deal.price?.currency?.code || "USD";
}

// Helper function to get deal prediction
export function getDealPrediction(deal: Deal): DealPrediction {
  return deal.prediction || "DEAL_PREDICTION_UNSPECIFIED";
}

// Helper function to get deals departing on a specific date
export function getDealsDepartingOn(
  deals: Deal[],
  date: string | Date | Dayjs
): Deal[] {
  const formattedDate = dayjs(date).format("YYYY-MM-DD");
  return deals.filter((deal) => getDealDepartureDate(deal) === formattedDate);
}

// Helper function to get deals returning on a specific date
export function getDealsReturningOn(
  deals: Deal[],
  date: string | Date | Dayjs
): Deal[] {
  const formattedDate = dayjs(date).format("YYYY-MM-DD");
  return deals.filter((deal) => getDealReturnDate(deal) === formattedDate);
}
